export default __webpack_public_path__ + "static/char-sp02-3ea222e9fd45645e5c394f8b7adebf52.gif";